import script from "./NoncurrentAssetClassifiedSale.vue?vue&type=script&setup=true&lang=js"
export * from "./NoncurrentAssetClassifiedSale.vue?vue&type=script&setup=true&lang=js"

import "./NoncurrentAssetClassifiedSale.vue?vue&type=style&index=0&id=84561bba&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84561bba"]])

export default __exports__